import { EmblaCarouselType, EmblaOptionsType } from "embla-carousel";
import { DotButton, useDotButton } from "./CarouselDotButton";
import useEmblaCarousel from "embla-carousel-react";
import clsx from "clsx";
import { FunctionalComponent, ComponentChildren } from "preact";

type PropType = {
  slides?: number[];
  options?: EmblaOptionsType;
  children: ComponentChildren;
  carouselRef: any;
  emblaApi: EmblaCarouselType | undefined;
};

export const Carousel: FunctionalComponent<PropType> = (props) => {
  const { children, options } = props;

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
    props.emblaApi
  );

  const childrenArray = Array.isArray(children)
    ? children.filter(Boolean)
    : children
      ? [children]
      : [];

  return (
    <section className="embla max-w-[48rem] w-full h-full relative">
      {/* Carousel content with overlayed dots */}
      <div
        className={clsx("embla__viewport overflow-hidden w-full h-full")}
        ref={props.carouselRef}
      >
        <div className="embla__container h-full w-full flex touch-pan-y touch-pinch-zoom ml-[calc(var(--slide-spacing)*-1)]">
          {childrenArray.map((child, index) => (
            <div
              key={index}
              className="embla__slide flex-[0_0_100%] min-w-0 pl-[var(--slide-spacing)]"
            >
              {child}
            </div>
          ))}
        </div>
      </div>

      {/* Dots overlayed on top of the carousel content */}
      {childrenArray.length > 1 && (
        <div className="embla__controls absolute bottom-[26px] w-full flex justify-center gap-5">
          <div className="embla__dots flex gap-1">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={
                  'embla__dot appearance-none bg-transparent cursor-pointer border-0 w-3 h-3 flex items-center justify-center after:w-2 after:h-2 after:rounded-full after:content-[""]' +
                  (index === selectedIndex
                    ? " embla__dot--selected after:bg-black"
                    : " after:bg-black after:bg-opacity-20")
                }
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
